import ReportsEmptyState from './ReportsEmptyState.component';

export default ReportsEmptyState;
